import styled from 'styled-components';
import { Box, Button, Heading, Text, createButtonPrimaryColorConfig } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import Attribution from '../../common/Attribution';

export default function AboutUs() {
    const cards = [
        {
            designer: 'foggyboxes',
            heading: 'We’re a creative platform',
            body: '99designs makes it easy to work with professional, creative experts from around the world and grow your brand through custom, memorable design.',
            image: {
                url: '99daysofdesign/about_us/Denis_Illustrates.jpg',
                alt: 'Illustration of a light bulb with a pencil tip with the text learn, create and inspire.',
            },
            profile: '/profiles/849964',
        },
        {
            designer: 'Asael Varas',
            heading: 'Build your brand in one place',
            body: 'From custom logos to clothing labels, our professional freelance designers can do it all. Explore our 90+ categories and get quality design.',
            image: {
                url: '99daysofdesign/about_us/Asael_Varas.jpg',
                alt: 'Illustration of a man with long twisted arms holding pencils pointing at a light bulb above his head.',
            },
            profile: '/profiles/808093',
        },
        {
            designer: 'Mad pepper',
            heading: 'Take it up a notch with Vistaprint',
            body: 'We’ve joined forces with Vistaprint to make printing your design easy and affordable. Choose from a huge range of products and bring your brand to life.',
            image: {
                url: '99daysofdesign/about_us/Mad_Pepper.jpg',
                alt: 'Illustration of a flying pig with a rocket on its back',
            },
            profile: '/profiles/895578',
        },
    ];

    return (
        <Box marginY="8bu">
            <Box display="flex" justifyContent="center" paddingBottom="3bu">
                <StyledHeading appearanceLevel={2} accessibilityLevel={3}>
                    A bit about us
                </StyledHeading>
            </Box>
            <CardsContainer display="flex">
                {cards.map((card) => (
                    <CardContent key={card.heading} paddingBottom="3bu">
                        <Box paddingBottom="1bu">
                            <DesignerImage
                                src={publicImageUrl(card.image.url)}
                                alt={card.image.alt}
                            />
                        </Box>
                        <Attribution name={card.designer} url={card.profile} size="subtle" />
                        <Box paddingTop="2bu" paddingBottom="1bu">
                            <Heading appearanceLevel={4} accessibilityLevel={5}>
                                {card.heading}
                            </Heading>
                        </Box>
                        <Text>{card.body}</Text>
                    </CardContent>
                ))}
            </CardsContainer>
            <Box display="flex" justifyContent="center">
                <Button
                    width={['fill', 'auto', 'auto', 'auto']}
                    appearance={createButtonPrimaryColorConfig({
                        color: '#AF356C',
                        backgroundColorHover: '#BF5D89',
                        backgroundColorActive: '#8E1C47',
                    })}
                    size="large"
                    href="/categories"
                    target="_blank"
                >
                    Explore design categories
                </Button>
            </Box>
        </Box>
    );
}

const CardContent = styled(Box)`
    &:nth-child(even) {
        padding: 0px 25px;
    }
`;

const CardsContainer = styled(Box)`
    ${mediaQuery.between('small', 'medium')} {
        flex-direction: column;
        text-align: center;
    }
`;

const StyledHeading = styled(Heading)`
    color: #af356c;
`;

const DesignerImage = styled.img`
    height: 250px;

    ${mediaQuery.between('small', 'medium')} {
        margin: auto;
    }
`;
